/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export type studentAnswers = {
    score:number;
    status:string;
    num_tries:number
    count_correct:number;
    count_wrong:number;
    count_marked:number;
    correctQuestions:Question[];
    markedQuestions:Question[];
    wrongQuestions:Question[];
};
type Question = {
    question:string;
    explanation:string;
    choices:Choices[]
}
type Choices = {
    answer:string;
    isCorrect:boolean;
    selected:boolean;
}
type GetAnswersResponse = {
    statusCode?: number;
    error?: ApiError | null;
    data?: studentAnswers;
};

export const GetStudentMcqAnswers = async (quizId: string,studentId:string,num_trial:number): Promise<GetAnswersResponse> => {
    try {
        const response = await axios.get(`/student-submit/studentAnswersQuiz/${quizId}/${studentId}/${num_trial}`);
            return { data: response.data };
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};